/// <reference path="../../../../typedefs/dash.js" />
import { isArray } from 'utils/types'

/**
 * A util to handle if location detail is an array or string.
 * Some details like JJ include J but they are not the same detail.
 * @param {{ DashComponent }} component
 * @param {{ DashLayoutLocation }} location
 * @returns {boolean}
 */
export const locationDetailIncludes = (component, location) => {
  const { detail: locationDetail } = location
  const { locationDetail: componentDetail } = component

  return Array.isArray(locationDetail)
    ? locationDetail.includes(componentDetail)
    : locationDetail === componentDetail
}

/**
 * Check if a component exist in on of list locations
 * @param {string | string[]} location
 * @param {object} state
 * @returns {boolean}
 */
export const doesALocationHaveAComponent = (location, components) =>
  isArray(location)
    ? location.some((loc) => components[loc])
    : Boolean(components[location])

export const DASH_TYPE_N_AU_PANEL_GAUGE_PROXIMITY_MAP = {
  AU001: {
    connectsWith: ['AU002', 'AU004', 'AU005', 'AU011', 'AU012'],
    noConnection: [
      'AU003',
      'AU006',
      'AU007',
      'AU008',
      'AU009',
      'AU010',
      'AU013',
      'AU014',
      'AU015',
      'AU016',
    ],
  },
  AU002: {
    connectsWith: [
      'AU001',
      'AU003',
      'AU005',
      'AU006',
      'AU011',
      'AU012',
      'AU013',
      'AU014',
    ],
    noConnection: [
      'AU004',
      'AU007',
      'AU008',
      'AU009',
      'AU010',
      'AU015',
      'AU016',
    ],
  },
  AU003: {
    connectsWith: ['AU002', 'AU006', 'AU007', 'AU012', 'AU013', 'AU014'],
    noConnection: [
      'AU001',
      'AU004',
      'AU005',
      'AU008',
      'AU009',
      'AU010',
      'AU011',
      'AU015',
      'AU016',
    ],
  },
  AU004: {
    connectsWith: ['AU001', 'AU005', 'AU008', 'AU011', 'AU012'],
    noConnection: [
      'AU002',
      'AU003',
      'AU006',
      'AU007',
      'AU009',
      'AU010',
      'AU013',
      'AU014',
      'AU015',
      'AU016',
    ],
  },
  AU005: {
    connectsWith: [
      'AU001',
      'AU002',
      'AU004',
      'AU006',
      'AU008',
      'AU009',
      'AU011',
      'AU012',
      'AU015',
    ],
    noConnection: ['AU003', 'AU007', 'AU010', 'AU013', 'AU014'],
  },
  AU006: {
    connectsWith: [
      'AU002',
      'AU003',
      'AU005',
      'AU007',
      'AU009',
      'AU010',
      'AU012',
      'AU013',
      'AU014',
      'AU015',
      'AU016',
    ],
    noConnection: ['AU001', 'AU004', 'AU008', 'AU011'],
  },
  AU007: {
    connectsWith: ['AU003', 'AU006', 'AU010', 'AU014', 'AU015', 'AU016'],
    noConnection: [
      'AU001',
      'AU002',
      'AU004',
      'AU005',
      'AU008',
      'AU009',
      'AU011',
      'AU012',
    ],
  },
  AU008: {
    connectsWith: ['AU004', 'AU005', 'AU009'],
    noConnection: [
      'AU001',
      'AU002',
      'AU003',
      'AU006',
      'AU007',
      'AU008',
      'AU010',
      'AU012',
      'AU013',
      'AU014',
      'AU015',
    ],
  },
  AU009: {
    connectsWith: ['AU005', 'AU006', 'AU008', 'AU010', 'AU015', 'AU016'],
    noConnection: [
      'AU001',
      'AU002',
      'AU003',
      'AU004',
      'AU007',
      'AU009',
      'AU011',
      'AU012',
      'AU013',
      'AU014',
    ],
  },
  AU010: {
    connectsWith: ['AU006', 'AU007', 'AU009', 'AU015', 'AU016'],
    noConnection: [
      'AU001',
      'AU002',
      'AU003',
      'AU004',
      'AU005',
      'AU008',
      'AU010',
      'AU011',
      'AU012',
      'AU013',
      'AU014',
    ],
  },
  AU011: {
    connectsWith: ['AU001', 'AU002', 'AU004', 'AU005', 'AU012'],
    noConnection: [
      'AU003',
      'AU006',
      'AU007',
      'AU008',
      'AU009',
      'AU010',
      'AU011',
      'AU012',
      'AU013',
      'AU014',
      'AU015',
      'AU016',
    ],
  },
  AU012: {
    connectsWith: [
      'AU001',
      'AU002',
      'AU003',
      'AU004',
      'AU005',
      'AU006',
      'AU011',
      'AU013',
      'AU014',
    ],
    noConnection: ['AU007', 'AU008', 'AU009', 'AU010', 'AU015', 'AU016'],
  },
  AU013: {
    connectsWith: [
      'AU001',
      'AU002',
      'AU003',
      'AU004',
      'AU005',
      'AU006',
      'AU007',
      'AU011',
      'AU012',
      'AU014',
    ],
    noConnection: ['AU008', 'AU009', 'AU010', 'AU015', 'AU016'],
  },
  AU014: {
    connectsWith: ['AU002', 'AU003', 'AU006', 'AU007', 'AU012', 'AU013'],
    noConnection: [
      'AU001',
      'AU004',
      'AU005',
      'AU008',
      'AU009',
      'AU010',
      'AU011',
      'AU015',
      'AU016',
    ],
  },
  AU015: {
    connectsWith: ['AU005', 'AU006', 'AU007', 'AU009', 'AU010', 'AU016'],
    noConnection: [
      'AU001',
      'AU002',
      'AU003',
      'AU004',
      'AU008',
      'AU011',
      'AU012',
      'AU013',
      'AU014',
    ],
  },
  AU016: {
    connectsWith: ['AU006', 'AU007', 'AU009', 'AU010', 'AU015'],
    noConnection: [
      'AU001',
      'AU002',
      'AU003',
      'AU004',
      'AU005',
      'AU008',
      'AU011',
      'AU012',
      'AU013',
      'AU014',
    ],
  },
}

export const DASH_TYPE_N_AU_PANEL_GAUGE_LOCATIONS = Object.keys(
  DASH_TYPE_N_AU_PANEL_GAUGE_PROXIMITY_MAP
)

export const DASH_TYPE_R_AU_PANEL_GAUGE_PROXIMITY_MAP = {
  AU001: {
    connectsWith: ['AU002', 'AU004', 'AU005'],
    noConnection: ['AU003', 'AU005', 'AU007', 'AU008'],
  },
  AU002: {
    connectsWith: ['AU001', 'AU003', 'AU004', 'AU005', 'AU007'],
    noConnection: ['AU004', 'AU006', 'AU008'],
  },
  AU003: {
    connectsWith: ['AU002', 'AU005', 'AU008'],
    noConnection: ['AU001', 'AU004', 'AU006', 'AU007'],
  },
  AU004: {
    connectsWith: ['AU001', 'AU002', 'AU005', 'AU006', 'AU007'],
    noConnection: ['AU003', 'AU008'],
  },
  AU005: {
    connectsWith: ['AU002', 'AU003', 'AU004', 'AU007', 'AU008'],
    noConnection: ['AU001', 'AU006'],
  },
  AU006: {
    connectsWith: ['AU001', 'AU004', 'AU007'],
    noConnection: ['AU002', 'AU003', 'AU005', 'AU008'],
  },
  AU007: {
    connectsWith: ['AU002', 'AU004', 'AU005', 'AU006', 'AU008'],
    noConnection: ['AU001', 'AU003'],
  },
  AU008: {
    connectsWith: ['AU003', 'AU005', 'AU007'],
    noConnection: ['AU001', 'AU002', 'AU004', 'AU006'],
  },
}

export const DASH_TYPE_R_AU_PANEL_GAUGE_LOCATIONS = Object.keys(
  DASH_TYPE_R_AU_PANEL_GAUGE_PROXIMITY_MAP
)
